const iOSPlatforms = [
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod'
]

const isIOS =
  iOSPlatforms.includes(window.navigator.platform) ||
  (window.navigator.userAgent.includes('Mac') &&
    'ontouchend' in window.document)

export { iOSPlatforms, isIOS }
